import type { RtiFieldSection, RtiFieldLeaf } from 'model/interfaces/rti-employee-data-fields';

export function getOrderedRtiSectionKeys(section: RtiFieldSection): string[] {
  return Object.keys(section);
}

export function getOrderedRtiSectionEntries(section: RtiFieldSection): [string, RtiFieldLeaf][] {
  return getOrderedRtiSectionKeys(section).map((k) => [k, section[k]!]);
}
